'use strict';

/**
 * Checks if a value is an array.
 *
 * @param x - The value to check.
 * @returns `true` if the value is an array, `false` otherwise.
 * @typeParam T - The type of the array elements.
 */ function isArray(x) {
    return Array.isArray(x);
}

module.exports = isArray;
